import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { User } from "../../../model/user";
import { UserGroupManagement } from "../../../model/userGroupManagement";

@Component({
  selector: 'app-move-user-dialog',
  templateUrl: './move-user-dialog.component.html',
  styleUrls: ['./move-user-dialog.component.css']
})
export class MoveUserDialogComponent implements OnInit {

  selection: string;

  constructor(public dialogRef: MatDialogRef<MoveUserDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogData: {user: User, groups: UserGroupManagement[] }) { }

  ngOnInit(): void {
    this.selection = this.dialogData.groups[0].userGroup.name;
  }

  cancel(): void {
    this.dialogRef.close()
  }

  move(): void {
    const index = this.dialogData.groups.findIndex(elem => elem.userGroup.name === this.selection);
    this.dialogRef.close(this.dialogData.groups[index].userGroup);
  }

  selectGroup(value: string) {
    this.selection = value;
  }
}
